import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import CourseListingItem2 from "~/components/CourseListingItem2";
import RichText from "~/components/RichText";
import Wrapper from "~/components/SliceWrapper";

/**
 * Props for `CourseListing`.
 */
export type CourseListingProps =
  SliceComponentProps<Content.CourseListingSlice>;

/**
 * Component for "CourseListing" Slices.
 */
const CourseListing: FC<CourseListingProps> = ({ slice }) => {
  const CC_COURSES = slice.primary.courses.filter(
    (item: any) => item.type === "college-credit",
  );
  const ENRICHMENT_COURSES = slice.primary.courses.filter(
    (item: any) => item.type === "enrichment",
  );

  return (
    // @ts-expect-error — SliceWrapper is an untyped JS component
    <Wrapper
      data-analytics-component="course-listing"
      slice={slice}
      suppressHydrationWarning
    >
      <div className="rte section-heading">
        <RichText field={slice.primary.heading} />
      </div>

      {CC_COURSES.length > 0 ? (
        <>
          <div className="grid grid-cols-1 lg:grid-cols-2 mb-10">
            <div>
              <RichText field={slice.primary.college_credit_copy} />
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4 mb-16 lg:grid-cols-2">
            {CC_COURSES.map((item: any, index: number) => {
              const theme = "theme-blue-medium";
              return (
                <CourseListingItem2
                  key={item.id || index}
                  data={item}
                  theme={theme}
                />
              );
            })}
          </div>
        </>
      ) : null}

      {ENRICHMENT_COURSES.length > 0 ? (
        <>
          <div className="grid-cols-1 lg:grid-cols-2 grid mb-10">
            <div>
              <RichText field={slice.primary.enrichment_copy} />
            </div>
          </div>
          <div className="grid-cols-1 lg:grid-cols-2 gap-4 grid">
            {ENRICHMENT_COURSES.map((item: any, index: number) => {
              const theme = "theme-gray-light";
              return (
                <CourseListingItem2
                  key={item.id || index}
                  data={item}
                  theme={theme}
                />
              );
            })}
          </div>
        </>
      ) : null}
    </Wrapper>
  );
};

export default CourseListing;
